import * as requests from '../requests'
export const getSession = async () => {
    const response = await requests.fetchSession()
    if (response.success) {
        return response.data;
    } else {
        throw new Error('Error in fetching session data');
    }
}